import s from "./index380.js";
import { createElementBlock as o, openBlock as t, Fragment as a, renderList as c, createBlock as m, resolveDynamicComponent as i } from "vue";
import l from "./index231.js";
const p = ["data-component"];
function u(n, _, d, f, C, $) {
  return t(), o("div", {
    "data-component": n.$options.name
  }, [
    (t(!0), o(a, null, c(n.cmsContent.children, (e, r) => (t(), m(i(e.label), {
      key: e.label + r,
      cmsContent: e,
      isInDisturber: !0
    }, null, 8, ["cmsContent"]))), 128))
  ], 8, p);
}
const D = /* @__PURE__ */ l(s, [["render", u]]);
export {
  D as default
};
